import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { ImageType, ImageEntity } from '../../../../global/types';
import { GlobalCta, GlobalImage } from '../../../../global';
import { Row, Col } from 'antd';
import { useLocale } from 'src/modules/locale';
import styles from './LayoutBlockMultiImage.module.scss';
import { withBreakpoints } from 'react-breakpoints';
import { breakpoints } from 'src/utils/breakpoints';
import { CtaProps } from 'src/modules/global/components/cta/Cta';
import { defaultHorizontalGutter } from 'src/utils/grid';

export interface LayoutBlockMultiImageProps {
  title: string;
  title_En?: string;
  title_De?: string;
  body_text: string;
  body_text_secondary: string;
  image1: ImageEntity;
  image2: ImageEntity;
  image3: ImageEntity;
  currentBreakpoint: string;
  button?: CtaProps;
}

const LayoutBlockMultiImage: React.FunctionComponent<LayoutBlockMultiImageProps> = (
  props: LayoutBlockMultiImageProps
) => {
  const { getLocalizedObject } = useLocale();
  const [hack, setHack] = useState('');

  // I don't know what kind of workaround was in place here before related to
  // title_En and title_De properties. For the preview functionality, however,
  // the workaround is not needed so I added `|| props?.title` as a fallback.
  //
  // https://hyamstudios.atlassian.net/browse/WK-11
  //
  const newProps = {
    ...props,
    title_en: props?.title_En || props?.title,
    title_de: props?.title_De || props?.title,
  };

  const {
    image1,
    image2,
    image3,
    body_text,
    body_text_secondary,
    title,
    currentBreakpoint,
    button,
  } = getLocalizedObject(newProps);

  useEffect(() => {
    setHack('hack');
  }, []);

  return (
    <div
      className={styles.container}
      key={`multi-image-${image1?.url}-${image2?.url}-${image3?.url}-${hack}`}>
      {breakpoints[currentBreakpoint] < breakpoints.md ? (
        <>
          <div className={styles.image1Container}>
            <Row gutter={[defaultHorizontalGutter, 0]}>
              <Col span={24}>
                <GlobalImage
                  type={ImageType.FullRow}
                  wrapRow={true}
                  {...image1}
                  captionSize="small"
                  ratio={3 / 4}
                />
              </Col>
            </Row>
          </div>
          <div className={styles.image2Container}>
            <Row gutter={[defaultHorizontalGutter, 0]}>
              <Col span={24}>
                <GlobalImage
                  type={ImageType.FullRow}
                  wrapRow={true}
                  {...image2}
                  captionSize="small"
                  ratio={3 / 4}
                />
              </Col>
            </Row>
          </div>
          <div className={classnames(styles.mainTextContainer, styles.textContainer)}>
            <h3>{title}</h3>
            <div dangerouslySetInnerHTML={{ __html: body_text }} />

            {!!button && (
              <div className={styles.buttonContainer}>
                <GlobalCta {...button} />
              </div>
            )}

            {!!body_text_secondary && (
              <div dangerouslySetInnerHTML={{ __html: body_text_secondary }} />
            )}
          </div>
          <div className={styles.image3Container}>
            <GlobalImage
              type={ImageType.FullRow}
              wrapRow={true}
              {...image3}
              captionSize="small"
              ratio={3 / 2}
            />
          </div>
        </>
      ) : (
        <Row gutter={[defaultHorizontalGutter, 0]}>
          <Col span={10}>
            <div className={styles.image1Container}>
              <GlobalImage
                type={ImageType.FullRow}
                wrapRow={true}
                {...image1}
                captionSize="small"
                ratio={3 / 4}
              />
            </div>
            <div className={styles.image2Container}>
              <GlobalImage
                type={ImageType.FullRow}
                wrapRow={true}
                {...image2}
                captionSize="small"
                ratio={3 / 4}
              />
            </div>
          </Col>
          <Col span={12} offset={2}>
            <div
              className={classnames(
                styles.mainTextContainer,
                styles.textContainer,
                !button && styles.noButton
              )}>
              <h3>{title}</h3>
              <div dangerouslySetInnerHTML={{ __html: body_text }} />
              {!!button && (
                <div className={styles.buttonContainer}>
                  <GlobalCta {...button} />
                </div>
              )}
            </div>
            <div className={styles.image3Container}>
              <GlobalImage
                type={ImageType.FullRow}
                wrapRow={true}
                {...image3}
                captionSize="small"
                ratio={3 / 2}
              />
            </div>
            <div
              className={styles.textContainer}
              dangerouslySetInnerHTML={{ __html: body_text_secondary }}
            />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default withBreakpoints(LayoutBlockMultiImage);
